// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-fluid[data-v-5bfd10b8]{width:100%}.container-fluid[data-v-5bfd10b8],.container-fluid[data-v-5bfd10b8] *,.container-fluid[data-v-5bfd10b8] :after,.container-fluid[data-v-5bfd10b8] :before{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
